import React from "react";
import { Link } from "@bloomberg/media-ui-article";

import { TranslatedMessage } from "~utils/i18n/translate";

import styles from "./styles.module.css";

export default function TipTout() {
    const contactUrl = "https://www.bloomberg.com/tips/";
    return (
        <div className={styles.tipToutContainer}>
            <Link href={contactUrl} target="_blank">
                <span className={styles.tipToutCopy}>
                    <TranslatedMessage
                        id="confidentialTip"
                        defaultMessage="Confidential tip?"
                    />
                </span>
                <div className={styles.tipToutLink}>
                    <TranslatedMessage
                        id="sendTip"
                        defaultMessage="Send a tip to our reporters"
                    />
                </div>
            </Link>
        </div>
    );
}
